module.exports = __webpack_public_path__ + "static/media/liam-right.c62f9395.PNG";